// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"H0-z"};